import PageHistoryState from "@crescentParts/Store/Data/PageHistory/PageHistoryState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

const initialState = {
    pageHistory: []
};
const reducer = {
    "Custom/PageHistory/addPage":(draft:Draft<PageHistoryState>,action:{pageHistory:string[]},)=>{
        draft.pageHistory = action.pageHistory
    },
}

export default createTypedReducerWithImmer(initialState, reducer);